/** Words and phrases shared by many screens. */
const common = {
  en: {
    done: "Done",
    loading: "Loading…",
    save: "Save",
    saving: "Saving…",
    saved: "Saved.",
    cancel: "Cancel",
    edit: "Edit",
    remove: "Remove",
    delete: "Delete",
    close: "Close",
    keep: "Keep",
    pullRefresh: {
      pull: "Pull down to refresh",
      release: "Release to refresh",
      refreshing: "Refreshing…",
      busyConfirm: "A sale is in progress and would be lost. Refresh anyway?",
    },
    retry: "Retry",
    dismiss: "Dismiss",
    confirm: "Confirm",
    add: "Add",
    search: "Search",
    from: "From",
    to: "To",
    until: "Until",
    total: "Total",
    optional: "optional",
    today: "Today",
    tomorrow: "Tomorrow",
    yesterday: "Yesterday",
    dateRange: {
      label: "Period",
      today: "Today",
      yesterday: "Yesterday",
      last7: "Last 7 days",
      thisMonth: "This month",
      all: "All time",
      custom: "Custom",
      from: "From",
      to: "To",
    },
    language: "Language",
    somethingWrong: "That did not work.",
    walkIn: "Walk-in customer",
    items: { one: "{count} item", other: "{count} items" },
    products: { one: "{count} product", other: "{count} products" },
    sales: { one: "{count} sale", other: "{count} sales" },
    each: "{price} each",
    payment: {
      cash: "Cash",
      card: "Card",
      mobile_payment: "Mobile",
      mobile_payment_long: "Mobile payment",
      credit: "Credit",
    },
    categories: {
      juice: "Juice",
      puff: "Puff bar",
      device: "Device",
      kit: "Kit",
      pod: "Pod",
      coil: "Coil",
      cotton: "Cotton",
      accessory: "Accessory",
      other: "Other",
    },
    categoriesPlural: {
      juice: "Juices",
      puff: "Puffs",
      device: "Devices",
      kit: "Kits",
      pod: "Pods",
      coil: "Coils",
      cotton: "Cotton",
      accessory: "Accessories",
      pack: "Packs",
    },
    subcategories: {
      device: { box: "Box mod", accu: "Accu mod", atomizer: "Atomizer" },
      kit: { mech: "Mech", coil: "Coil" },
      accessory: {
        box_protection: "Box protection",
        ring: "Ring",
        drip_tube: "Drip tip",
        accu_charger: "Battery charger",
        pyrex: "Pyrex glass",
      },
    },
  },

  fr: {
    done: "Terminé",
    loading: "Chargement…",
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Enregistré.",
    cancel: "Annuler",
    edit: "Modifier",
    remove: "Retirer",
    delete: "Supprimer",
    close: "Fermer",
    keep: "Garder",
    pullRefresh: {
      pull: "Tirez vers le bas pour actualiser",
      release: "Relâchez pour actualiser",
      refreshing: "Actualisation…",
      busyConfirm: "Une vente est en cours et serait perdue. Actualiser quand même ?",
    },
    retry: "Réessayer",
    dismiss: "Ignorer",
    confirm: "Confirmer",
    add: "Ajouter",
    search: "Rechercher",
    from: "Du",
    to: "Au",
    until: "Jusqu'au",
    total: "Total",
    optional: "facultatif",
    today: "Aujourd'hui",
    tomorrow: "Demain",
    yesterday: "Hier",
    dateRange: {
      label: "Période",
      today: "Aujourd'hui",
      yesterday: "Hier",
      last7: "7 derniers jours",
      thisMonth: "Ce mois-ci",
      all: "Tout",
      custom: "Personnalisée",
      from: "Du",
      to: "Au",
    },
    language: "Langue",
    somethingWrong: "Cela n'a pas fonctionné.",
    walkIn: "Client de passage",
    items: { one: "{count} article", other: "{count} articles" },
    products: { one: "{count} produit", other: "{count} produits" },
    sales: { one: "{count} vente", other: "{count} ventes" },
    each: "{price} l'unité",
    payment: {
      cash: "Espèces",
      card: "Carte",
      mobile_payment: "Mobile",
      mobile_payment_long: "Paiement mobile",
      credit: "Crédit",
    },
    categories: {
      juice: "E-liquide",
      puff: "Puff",
      device: "Appareil",
      kit: "Kit",
      pod: "Pod",
      coil: "Résistance",
      cotton: "Coton",
      accessory: "Accessoire",
      other: "Autre",
    },
    categoriesPlural: {
      juice: "E-liquides",
      puff: "Puffs",
      device: "Appareils",
      kit: "Kits",
      pod: "Pods",
      coil: "Résistances",
      cotton: "Coton",
      accessory: "Accessoires",
      pack: "Packs",
    },
    subcategories: {
      device: { box: "Box", accu: "Mod à accu", atomizer: "Atomiseur" },
      kit: { mech: "Méca", coil: "Résistance" },
      accessory: {
        box_protection: "Protection de box",
        ring: "Bague",
        drip_tube: "Drip tip",
        accu_charger: "Chargeur de batterie",
        pyrex: "Verre pyrex",
      },
    },
  },

  ar: {
    done: "تم",
    loading: "جارٍ التحميل…",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    saved: "تم الحفظ.",
    cancel: "إلغاء",
    edit: "تعديل",
    remove: "إزالة",
    delete: "حذف",
    close: "إغلاق",
    keep: "إبقاء",
    pullRefresh: {
      pull: "اسحب للأسفل للتحديث",
      release: "أفلت للتحديث",
      refreshing: "جارٍ التحديث…",
      busyConfirm: "هناك عملية بيع جارية وستضيع. هل تريد التحديث رغم ذلك؟",
    },
    retry: "إعادة المحاولة",
    dismiss: "تجاهل",
    confirm: "تأكيد",
    add: "إضافة",
    search: "بحث",
    from: "من",
    to: "إلى",
    until: "حتى",
    total: "المجموع",
    optional: "اختياري",
    today: "اليوم",
    tomorrow: "غداً",
    yesterday: "أمس",
    dateRange: {
      label: "الفترة",
      today: "اليوم",
      yesterday: "أمس",
      last7: "آخر 7 أيام",
      thisMonth: "هذا الشهر",
      all: "الكل",
      custom: "مخصصة",
      from: "من",
      to: "إلى",
    },
    language: "اللغة",
    somethingWrong: "لم تنجح العملية.",
    walkIn: "زبون عابر",
    items: {
      zero: "لا قطع",
      one: "قطعة واحدة",
      two: "قطعتان",
      few: "{count} قطع",
      many: "{count} قطعة",
      other: "{count} قطعة",
    },
    products: {
      zero: "لا منتجات",
      one: "منتج واحد",
      two: "منتجان",
      few: "{count} منتجات",
      many: "{count} منتجاً",
      other: "{count} منتج",
    },
    sales: {
      zero: "لا مبيعات",
      one: "عملية بيع واحدة",
      two: "عمليتا بيع",
      few: "{count} عمليات بيع",
      many: "{count} عملية بيع",
      other: "{count} عملية بيع",
    },
    each: "{price} للقطعة",
    payment: {
      cash: "نقداً",
      card: "بطاقة",
      mobile_payment: "هاتف",
      mobile_payment_long: "دفع عبر الهاتف",
      credit: "دَين",
    },
    categories: {
      juice: "سائل",
      puff: "بف",
      device: "جهاز",
      kit: "طقم",
      pod: "بود",
      coil: "كويل",
      cotton: "قطن",
      accessory: "إكسسوار",
      other: "أخرى",
    },
    categoriesPlural: {
      juice: "سوائل",
      puff: "بف",
      device: "أجهزة",
      kit: "أطقم",
      pod: "بودات",
      coil: "كويلات",
      cotton: "قطن",
      accessory: "إكسسوارات",
      pack: "باقات",
    },
    subcategories: {
      device: { box: "بوكس", accu: "جهاز بطارية", atomizer: "أتومايزر" },
      kit: { mech: "ميكانيكي", coil: "كويل" },
      accessory: {
        box_protection: "واقي البوكس",
        ring: "حلقة",
        drip_tube: "دريب تيب",
        accu_charger: "شاحن البطارية",
        pyrex: "زجاج بايركس",
      },
    },
  },
};

export default common;
